import { render } from "./V2ProductCardLegacy.vue?vue&type=template&id=2ace18b8&scoped=true"
import script from "./V2ProductCardLegacy.vue?vue&type=script&lang=js"
export * from "./V2ProductCardLegacy.vue?vue&type=script&lang=js"

import "./V2ProductCardLegacy.vue?vue&type=style&index=0&id=2ace18b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.33_vue@3.5.33_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ace18b8"]])

export default __exports__